/**
 * PageLayout – wraps every inner page with the site Navbar and Footer.
 * Also renders the inner-page banner (hero strip with breadcrumb).
 */
import Navbar from './Navbar';
import Footer from './Footer';
import { Link } from 'react-router-dom';

export default function PageLayout({ title, breadcrumb, children }) {
  return (
    <div className="sa-page">
      <Navbar />

      {/* ── Inner page banner (commented out — hidden on All Courses page) ──
      <div className="sa-inner-banner">
        <div className="sa-inner-banner-overlay">
          <div className="sa-container">
            <h1 className="sa-inner-banner-title">{title}</h1>
            <ul className="sa-breadcrumb">
              <li><Link to="/">Home</Link></li>
              <li>{breadcrumb || title}</li>
            </ul>
          </div>
        </div>
      </div>
      ── end inner page banner ── */}

      {/* ── Page content ── */}
      <main className="sa-inner-content">
        {children}
      </main>

      <Footer />
    </div>
  );
}
